var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-logo",class:[_vm.inverse && 'ds-logo-inverse']},[(!_vm.inverse)?_c('svg-logo',{staticClass:"ds-logo-svg"}):_c('svg-logo-inverse',{staticClass:"ds-logo-svg"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }